<template>
  <ancestryline-modal title="protocol.tab-general.actions.print-budget"  id="protocol-printbudget-modal" :close="true" @close="close" :loading="false">

    <card>
      <coff-input-text-editor v-model="finalBudget" label="forms.annotation-card.annotation"/>
    </card>

    <template #footer>
      <Button class="p-mr-2" @click="close()">{{$t('btn.cancel')}}</Button>
      <div class="p-ml-auto">
        <Button :label="$t('protocol.tab-general.actions.print-budget')" @click="printBudget" class="p-ml-2"/>
      </div>
    </template>

  </ancestryline-modal>
</template>

<script>
import DialogService from "@/business/ModalBusiness";

export default {
  name: "ModalEditBudget",

  props: {
    originalBudget: {type: String, default: ""}
  },

  mounted() {
    this.finalBudget = this.originalBudget;
  },

  data(){
    return {
      finalBudget: "",
    }
  },

  methods:{
    close(){
      DialogService.closeModal();
    },
    printBudget(){
      DialogService.closeModal(this.finalBudget);
    }
  }
}
</script>